export const setOnlineStatus = (status) => {
  return {
    type: "SET_ONLINE_STATUS",
    payload: status
  }
}